import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quality-standards/page.tsx");
